// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EPCYA{position:absolute;top:63px;width:100%}.ZHYqZ{width:100%}.TdMmF{left:-18px;top:-25px}`, "",{"version":3,"sources":["webpack://./src/components/heroBanner/HeroBanner.module.scss"],"names":[],"mappings":"AAAA,OACE,iBAAA,CACA,QAAA,CACA,UAAA,CAGF,OACE,UAAA,CAGF,OACE,UAAA,CACA,SAAA","sourcesContent":[".container {\n  position: absolute;\n  top: 63px;\n  width: 100%;\n}\n\n.containerTop {\n  width: 100%;\n}\n\n.backgroundTitle {\n  left: -18px;\n  top: -25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EPCYA`,
	"containerTop": `ZHYqZ`,
	"backgroundTitle": `TdMmF`
};
export default ___CSS_LOADER_EXPORT___;
